import * as React from "react";
import { MainHeading, GroupingDropdown, HeadingTitle, ToggleOddsBtn, ToggleOddsBtnType } from "../../components";
import { InstantCollapsible } from "sb-resp-ui";
import { RenderMarketNames } from "../RenderComponents/RenderMarketNames";
import { CardType, MarketTemplate } from "../../../../data";
import { marketColumnsDisplay } from "../../../../constants";
import { ContainerQuery } from "react-container-query";
import { Params } from "react-container-query/lib/interfaces";

export class MainContent extends React.PureComponent<{
    id: string
    name: string
    eventsCount: string
    filterProps?: any
    shouldCollapse: boolean
    toggleOddsBtn?: ToggleOddsBtnType
    marketNames: Array<Array<string>>
    marketTemplates: MarketTemplate[]
    cardType: CardType
}, {}> {

    renderGroupingDropdown() {
        return this.props.filterProps && this.props.filterProps.shouldShow &&
            <GroupingDropdown {...this.props.filterProps} />
    }

    renderToggleButton() {
        return this.props.toggleOddsBtn && this.props.toggleOddsBtn.shouldShow &&
            <ToggleOddsBtn {...this.props.toggleOddsBtn} />
    }

    renderMarketNames(params?: Params) {
        return this.props.marketNames.length > 0 &&
            <RenderMarketNames marketNames={this.props.marketNames} marketTemplates={this.props.marketTemplates} queryParams={params} />
    }

    renderHeading(renderChildren: boolean, params?: Params) {
        return <>
            <MainHeading
                key={`sport-${this.props.id}`}
                cardType={this.props.cardType}
            >
                <HeadingTitle name={this.props.name} eventsCount={this.props.eventsCount} />
                {this.renderMarketNames(params)}
                {this.renderToggleButton()}
                {this.renderGroupingDropdown()}
            </MainHeading>
            {renderChildren && this.props.children}
        </>
    }

    renderHeadingWrapper(renderChildren: boolean) {
        return this.props.cardType === CardType.Multiview
            ? <ContainerQuery query={marketColumnsDisplay}>
                {(params) => this.renderHeading(renderChildren, params)}
            </ContainerQuery>
            : this.renderHeading(renderChildren);
    }

    render() {
        return <div className="rj-ev-list__content" key={`sport-${this.props.id}-content`} data-uat="div-ev-list-content">
            {this.props.shouldCollapse
                ? (<InstantCollapsible key={`collapse-subheading-${this.props.id}`} initiallyExpanded={true} trigger={this.renderHeadingWrapper(false)}
                    content={
                        <>
                            {this.props.children}
                        </>
                    }
                />)
                : this.renderHeadingWrapper(true)}
        </div>
    }
}